module.exports = __webpack_public_path__ + "img/title4.7b8528c6.png";